{
	"core": {
		"general": {
			"fieldValidationNotMatchingError": "{{fieldLabel}} no coincide",
			"fieldValidationNumberError": "{{fieldLabel}} debe ser un numero",
			"fieldValidationRequiredError": "{{fieldLabel}} es requerido",
			"fieldValidationNumberOverMaxError": "{{fieldLabel}} debe ser igual o inferior a {{max}}",
			"fieldValidationNumberUnderMinError": "{{fieldLabel}} debe ser igual o superior a {{min}}",

			"exerciseActivityTypeBasketball": "Baloncesto",
			"exerciseActivityTypeBoxing": "Boxeo",
			"exerciseActivityTypeCycling": "Ciclismo",
			"exerciseActivityTypeDance": "Baile",
			"exerciseActivityTypeElliptical": "Elíptica",
			"exerciseActivityTypeOther": "Otro",
			"exerciseActivityTypeRunning": "Running",
			"exerciseActivityTypeSoccer": "Futbol",
			"exerciseActivityTypeSwimming": "Natación",
			"exerciseActivityTypeTennis": "Tenis",
			"exerciseActivityTypeWalking": "Caminata",
			"exerciseActivityTypeWeightLifting": "Levantamiento de pesas",
			"exerciseActivityTypeYoga": "Yoga",
			"mealTypeBreakfast": "Desayuno",
			"mealTypeDinner": "Cena",
			"mealTypeLunch": "Almuerzo",
			"mealTypeSnacks": "Merienda",
			"ratingType1": "Súper triste",
			"ratingType2": "Triste",
			"ratingType3": "Feliz",
			"ratingType4": "Genial",
			"sexTypeFemale": "Femenino",
			"sexTypeMale": "Masculino"
		},
		"moduleDetails": {
			"title": "Módulo",
			"title_1": "Bienvenida al paciente",
			"title_2": "Ejercicio",
			"title_3": "Fundamentos de la alimentación 1",
			"title_4": "Fundamentos de la alimentación 2",
			"title_5": "Fundamentos de la alimentación 3",
			"title_6": "Macronutrientes",
			"title_7": "Transformación de comidas",
			"title_8": "Hidratación",
			"title_9": "Vitaminas y minerales",
			"title_10": "Vida post-operatoria 1",
			"title_11": "Vida post-operatoria 2",
			"title_12": "Vida post-operatoria 3"
		},
		"lessonDetails": {
			"title": "Clase",
			"title_1-1": "Bienvenida al Paciente",
			"title_1-2": "La obesidad es una enfermedad",
			"title_2-1": "Ejercicio",
			"title_3-1": "El sistema no funciona",
			"title_3-2": "El mejor sistema",
			"title_3-3": "Cirugía de pérdida de peso",
			"title_4-1": "¿Para qué sirve la comida?",
			"title_4-2": "El fiasco de la comida dietética",
			"title_5-1": "Azucar",
			"title_5-2": "Calorias",
			"title_5-3": "Etiqueta nutricional 101",
			"title_6-1": "Proteína",
			"title_6-2": "Carbohidratos",
			"title_6-3": "Grasas",
			"title_7-1": "Mentalidad de las comidas: Plato saludable",
			"title_7-2": "Planificación de comidas (Meal Planning)",
			"title_8-1": "Hidratación",
			"title_9-1": "Vitaminas y minerales",
			"title_10-1": "Progresión de la dieta",
			"title_10-2": "Comiendo para un nuevo tú",
			"title_11-1": "Riesgos",
			"title_11-2": "Apoyo y responsabilidad",
			"title_11-3": "Cambios de hábitos positivos",
			"title_12-1": "Rompiendo mitos",
			"title_12-2": "La linea de meta",
			"title_12-3": "Definición de objetivos",
			"description": "NewTri® Health es un programa educativo interactivo con vídeos que le preparará para afrontar con éxito la cirugía bariátrica y le proporcionará las herramientas necesarias para mantenerse sano el resto de su vida.",
			"description_1-2": "Lo crea o no, acaba de tomar una de las decisiones más importantes de su vida.\n\nExplore los numerosos riesgos y daños de los cuales las personas se liberan al superar la obesidad.",
			"description_2-1": "¿Vale la pena hacer ejercicio? Eso depende. Mucha gente espera que el ejercicio haga algo que sencillamente no puede hacer.\n\nDescubra en qué consiste y conozca los beneficios que puede aportarle una vida activa adecuada para usted.",
			"description_3-1": "Hay una razón por la que las dietas y los medicamentos no funcionan. En realidad, hay varias razones.\n\nExaminemos por qué los sistemas de pérdida de peso fracasan y le dejan sintiéndose atrapado en una condición de la que ha intentado escapar con tanto esfuerzo.",
			"description_3-2": "Si las dietas y los medicamentos no pueden ayudarnos a superar la obesidad, ¿qué puede hacerlo?\n\n¡No pierda la esperanza!. Usted puede recuperar su salud, y está a punto de aprender la fórmula que funciona. Conozca los cuatro pasos que analizaremos durante el resto del curso de manera detallada",
			"description_3-3": "Nos hacemos un gran favor cuando hacemos ejercicio y cambiamos nuestra relación con la comida. Resulta tentador detenerse ahí y evitar la cirugía para perder peso. La cuestión es la siguiente: la cirugía transforma nuestro cuerpo de dos maneras cruciales.\n\nEntérese de esos cambios en este vídeo.",
			"description_4-1": "Cuando establecemos una nueva relación con la comida, desarrollamos una comprensión más profunda de lo que ésta hace. No cabe duda de que estamos hechos para disfrutar de la comida, pero primero tenemos que conocer su propósito.\n\nVamos a reformular nuestra forma de entender la comida, y a analizar dos categorías básicas de nutrición.",
			"description_4-2": "Noticias de última hora: Los anunciantes no siempre dicen toda la verdad. Los envases de los alimentos a menudo distorsionan la realidad de maneras que van en contra de nuestra salud.\n\nAprenda a mirar más allá de las etiquetas. He aquí lo que suelen ocultar los productos sin grasa y lo que debe buscar para que sus elecciones bien intencionadas le ayuden realmente a perder peso.",
			"description_5-1": "¿Qué hace que el azúcar de una fresa sea mejor que el azúcar de, por ejemplo, un helado de fresa?\n\nAquí veremos cómo reacciona nuestro cuerpo ante el azúcar. Examinaremos la sustancia química que producimos para transformar lo dulce en combustible, y lo que ocurre cuando comemos cosas que provocan que nuestro cuerpo produzca demasiada cantidad de esa sustancia química.",
			"description_5-2": "Si quiere perder peso, encontrará muchas herramientas que le ayudarán a contar calorías. Por desgracia, los recuentos de calorías dejan fuera la información que realmente necesita. Tiene que saber qué tipo de energía le está dando a su cuerpo.\n\nEste vídeo revela el tipo de calorías que hay que evitar y las que alimentan nuestra energía, nuestra fuerza y nuestro bienestar.",
			"description_5-3": "Recuerde esto: Si un alimento tiene etiqueta, debe leerla. El gobierno mantiene a las empresas honestas con estas etiquetas, y pueden ayudarle a elegir los tipos y las cantidades correctas de combustible para su día.\n\nCuando lea una etiqueta, preste atención a estos datos clave y utilice las guías de este vídeo para elegir correctamente los tipos de combustible.",
			"description_6-1": "Ahora, hablemos de la gran categoría de nutrientes que hace que su cuerpo se sienta lleno, aumente el metabolismo y queme grasa corporal. ¿Hemos mencionado que mantiene y aumenta la masa muscular y repone la energía?\n\nHablamos de las proteínas. Aprenda qué cantidad de este macronutriente debe buscar por comida, así como por día. Además, sepa qué proteínas elegir, incluso si no come carne.",
			"description_6-2": "Cuando estudia nutrición, puede empezar a creer que debe evitar todos los carbohidratos. Resulta que no es así. Algunos carbohidratos proporcionan fibra, energía a largo plazo y nutrientes para nuestro sistema digestivo. Los necesitamos — con moderación.\n\nEste vídeo le revela la mejor clase de carbohidratos y le ofrece un sencillo truco para asegurarse de que está comiendo la cantidad adecuada de carbohidratos hoy.",
			"description_6-3": "¿Qué categoría principal de nutrientes confunde más a la gente? La respuesta, por supuesto, es la grasa. Eso se debe a que algunos tipos de grasa suponen enormes amenazas para nuestra salud. Mientras tanto, otros tipos de grasa son tan importantes que deberían constituir un tercio de lo que comemos cada día.\n\nAprenda a evitar las grasas perjudiciales y a hacer de las útiles una parte clave de lo que alimenta su cuerpo.",
			"description_7-1": "Ahora que conoce mejor sus macronutrientes —proteínas, carbohidratos y grasas— hablemos de cuándo este conocimiento es más importante, la hora de comer. ¿Qué porcentaje de su plato debe ir a cada macronutriente\n\nLe daremos una forma sencilla de imaginar su plato para que pueda mantener sus proporciones correctas.",
			"description_7-2": "Seamos sinceros. La planificación de las comidas no tiene nada de atractivo. Sin embargo, elegir lo que va a comer con antelación le protege de las consecuencias de saltarse comidas y de comer compulsivamente.\n\nConsulte estos tres pasos para ser intencionado con sus comidas.",
			"description_8-1": "¿Cuál es la forma número uno de evitar complicaciones tras una operación de pérdida de peso? Beber mucha agua. Es posible que se enfrente a cierta resistencia en esto porque su nuevo estómago se sentirá lleno rápidamente.\n\nEste vídeo le da algunos trucos sencillos para obtener suficiente agua y darle a su cuerpo la hidratación que necesita para construir su nuevo yo.",
			"description_9-1": "Es irónico. Un sistema descompuesto nos lleva a comer más de lo que nuestro cuerpo necesita, pero acabamos careciendo de componentes esenciales como vitaminas y micronutrientes.\n\nMire cómo unos pocos suplementos nos ayudan y nos protegen de las deficiencias, especialmente tras una operación de pérdida de peso.",
			"description_10-1": "Después de su cirugía de pérdida de peso, es conveniente que sea delicado con su estómago para ayudarle a cicatrizar. Y la mejor manera de evitar complicaciones durante la recuperación es cumplir con la secuencia de la dieta establecida por su médico.\n\nVamos a tener una visión general de la manera en que progresarán sus comidas durante esas semanas clave de cambio.",
			"description_10-2": "A menudo, la gente se siente ansiosa por cómo cambiarán sus patrones alimenticios después de la cirugía. Es un cambio significativo, así que esos nervios son comprensibles.\n\nPero afortunadamente, si sigue estos consejos y pautas durante la recuperación, no tendrá nada de qué preocuparse.",
			"description_11-1": "Toda historia contiene retos, riesgos y conflictos. Usted está al principio de una nueva historia inspiradora, y tendrá muchas oportunidades de superar verdaderas barreras, incluso en su propia mente.\n\nEste vídeo resalta la necesidad de alimentar nuestra mentalidad y nuestras emociones y de encontrar mucho apoyo en el camino.",
			"description_11-2": "Nadie invierte en una operación de pérdida de peso porque quiera estar sano durante un tiempo. Desgraciadamente, los pacientes se enfrentan a una tonelada de presiones que pueden deshacer sus progresos, ganados con tanto esfuerzo.\n\nEn este vídeo se explica por qué las relaciones que mantiene pueden hacer o deshacer su viaje de pérdida de peso.",
			"description_11-3": "He aquí una pregunta: ¿Cuál es la diferencia entre un deseo y un objetivo? Las personas que han conseguido transformar su salud nos dicen que es mucho más probable que los objetivos adecuados mejoren nuestros hábitos más que las grandes ambiciones.\n\nVea estos consejos para fijar objetivos y qué hacer los días en que no los cumplimos.",
			"description_12-1": "No es ningún secreto que nuestro mundo está plagado de desinformación sobre la pérdida de peso. También hemos oído más de unas cuantas nociones falsas sobre la cirugía de pérdida de peso. Pongamos las cosas en claro, para que pueda seguir avanzando en la dirección correcta.",
			"description_12-2": "¡Felicidades! Al completar este curso, se ha dotado de una gran cantidad de conocimientos sobre la cirugía de pérdida de peso y la vida sana. Esperemos que estos conocimientos hayan reforzado su confianza en que puede tener éxito y lo tendrá. Para refrescarle la memoria, echemos un vistazo a algunos de los puntos clave de este curso.",
			"description_12-3": "¿Qué hace cuando el camino se hace largo? Ya hemos hablado de la importancia de desarrollar una mentalidad saludable sobre la pérdida de peso. Parte de eso significa que recordemos lo que nos motivó en primer lugar, nuestro por qué.\n\nPuede volver a este vídeo siempre que necesite otra dosis de propósito."
		},
		"questionDetails": {
			"text": "Pregunta desconocida. Póngase en contacto con el administrador de su programa.",
			"text_1-2-6": "La obesidad conduce a?",
			"text_1-2-7": "La obesidad puede provocar",
			"text_1-2-8": "¿Qué IMC categoriza la obesidad?",
			"text_1-2-9": "¿Qué efecto tiene la cirugía de pérdida de peso sobre los problemas de salud asociados a la obesidad mórbida?",
			"text_2-1-0": "¿Cuál de estos es un beneficio del ejercicio?",
			"text_2-1-1": "¿Cómo afecta el ejercicio a su peso?",
			"text_2-1-2": "El ejercicio tiene que ser muy extenuante para ser eficaz",
			"text_2-1-3": "Si se pierde un día de ejercicio, ¿qué debe hacer?",
			"text_2-1-4": "¿Cómo debe determinar qué tipo de ejercicios hacer?",
			"text_2-1-5": "Los hábitos de ejercicio deberían ser:",
			"text_3-1-0": "¿Cuál debe ser el objetivo de un sistema de pérdida de peso?",
			"text_3-1-1": "Se ha demostrado que las dietas de moda y las píldoras ayudan a los pacientes a perder peso y a mantenerlo para siempre",
			"text_3-1-2": "¿Por qué no funcionan las dietas?",
			"text_3-1-3": "¿Cuál es la clave para hacer cambios permanentes para su salud?",
			"text_3-1-4": "¿Cuál <emphasis>no</emphasis> es  un efecto secundario de las pastillas para adelgazar?",
			"text_3-1-5": "El riesgo de efectos adversos al tomar pastillas para adelgazar aumenta cuando se padecen enfermedades preexistentes",
			"text_3-2-0": "Todos los siguientes son componentes del actual sistema fallido de pérdida de peso <emphasis>excepto</emphasis>?",
			"text_3-2-1": "¿Cuál de los siguientes no forma parte de la fórmula del éxito?",
			"text_3-2-2": "Una vez que haya perdido peso, ¿qué es lo más importante que tiene que hacer para mantenerse sano a largo plazo?",
			"text_3-2-3": "Los hábitos de ejercicio deberían ser:",
			"text_3-2-4": "Con el fin de mejorar su mentalidad para la pérdida de peso, debe cambiar su:",
			"text_3-2-5": "Las Victorias no relacionadas con la báscula (VNRB) son victorias que:",
			"text_3-3-0": "La cirugía de pérdida de peso es una parte fundamental de la fórmula de pérdida de peso",
			"text_3-3-1": "La cirugía de pérdida de peso puede ayudar con todo lo siguiente <emphasis>excepto</emphasis>...",
			"text_3-3-2": "La cirugía de pérdida de peso ayuda a prevenir, mejorar o resolver más de 40 enfermedades relacionadas con la obesidad, entre ellas:",
			"text_3-3-3": "Los cambios metabólicos que se producen tras la cirugía de pérdida de peso ayudan a:",
			"text_4-1-0": "¿Cuál es la mejor manera de pensar sobre la comida?",
			"text_4-1-1": "Los macronutrientes son",
			"text_4-1-2": "Los micronutrientes incluyen",
			"text_4-1-3": "Los micronutrientes regulan el ritmo cardiaco y el metabolismo y ayudan a prevenir enfermedades",
			"text_4-2-0": "Los alimentos etiquetados como libres de grasa son mejores para usted",
			"text_4-2-1": "Cuando los alimentos se etiquetan como libres de grasa, ¿qué suele significar esto?",
			"text_4-2-2": "En el supermercado, ¿cómo decide si un alimento envasado es bueno para usted?",
			"text_4-2-3": "¿Cuál de ellos le hace ganar peso?",
			"text_5-1-0": "El exceso de azúcar se almacena como",
			"text_5-1-1": "Una buena filosofía sobre el azúcar es",
			"text_5-1-2": "El azúcar es",
			"text_5-1-3": "El azúcar de media taza de fresas es el mismo que el de media taza de helado de fresa",
			"text_5-2-0": "Si compara un huevo frente a una rebanada de pan blanco, tienen las mismas calorías. Por lo tanto, son igual de nutritivos",
			"text_5-2-1": "Al comparar un huevo frente a una rebanada de pan, ¿cuál es mejor para usted y por qué?",
			"text_5-2-2": "¿Por qué no funciona contar calorías?",
			"text_5-2-3": "Es mejor elegir alimentos con grandes cantidades de proteínas en lugar de alimentos con grandes cantidades de carbohidratos, aunque los alimentos ricos en proteínas tengan algo más de calorías",
			"text_5-3-0": "¿Qué es lo primero que debe mirar en la etiqueta nutricional?",
			"text_5-3-1": "Debe evitar un alimento que contenga ¿cuál de los siguientes?",
			"text_5-3-2": "¿Qué quiere intentar limitar a 15 gramos al día?",
			"text_5-3-3": "¿Cuál quiere que contenga 35 gramos por comida?",
			"text_6-1-0": "Las proteínas le ayudan",
			"text_6-1-1": "Todos los alimentos son igual de buenos para usted si contienen la misma cantidad de proteínas",
			"text_6-1-2": "Las mejores fuentes de proteínas son",
			"text_6-1-3": "¿Qué porcentaje de su comida deben ser proteínas?",
			"text_6-1-4": "La proteína es el macronutriente más importante después de una operación",
			"text_6-2-0": "¿Qué tipo de carbohidrato no es tan bueno para la salud y la pérdida de peso?",
			"text_6-2-1": "Los carbohidratos complejos se encuentran en",
			"text_6-2-2": "Los carbohidratos complejos son mejores para usted que los carbohidratos simples por todas las siguientes razones <emphasis>excepto</emphasis>:",
			"text_6-2-3": "Para calcular los carbohidratos netos",
			"text_6-2-4": "Manténgase por debajo de esta cantidad de carbohidratos netos si está intentando perder peso:",
			"text_6-3-0": "¿Qué tipo de grasa debe evitar por completo?",
			"text_6-3-1": "¿Qué alimentos tienen una buena cantidad de grasas insaturadas?",
			"text_6-3-2": "Las grasas insaturadas ayudan",
			"text_6-3-3": "Las grasas saturadas pueden ayudar en algunos de los mismos aspectos que las insaturadas, pero deben consumirse con moderación. ¿Qué alimento es un ejemplo de grasa saturada?",
			"text_7-1-0": "¿¿Cuántas onzas de proteína magra debería apuntar a consumir en cada comida?",
			"text_7-1-1": "¿Cuál es una de las cosas más fáciles que puede hacer para evitar comer en exceso y asegurarse de que consume raciones más pequeñas?",
			"text_7-1-2": "¿Qué regla le ayuda a asegurarse de que obtiene un buen equilibrio de alimentos en cada comida?",
			"text_7-1-3": "Las verduras sin almidón deben consumirse una vez que se haya saciado de proteínas",
			"text_7-1-4": "Las proteínas magras deberían",
			"text_7-1-5": "Una vez colocado su plato, ¿qué debe comer siempre primero?",
			"text_7-2-0": "Saltarse comidas puede",
			"text_7-2-1": "Todas las siguientes son reglas básicas para planificar comidas sanas <emphasis>excepto</emphasis>:",
			"text_7-2-2": "¿Cómo puede evitar comer demasiados snacks?",
			"text_7-2-3": "¿Cómo debe actuar cuando come fuera de casa?",
			"text_7-2-4": "Debería hacer <emphasis>siempre</emphasis> tres comidas al día",
			"text_8-1-0": "La deshidratación es la razón número uno por la que la gente es hospitalizada después de una operación",
			"text_8-1-1": "Las formas de evitar la deshidratación postoperatoria incluyen todas las siguientes <emphasis>excepto</emphasis>:",
			"text_8-1-2": "¿Cuánta agua debe intentar consumir cada día?",
			"text_8-1-3": "¿Qué bebida debe evitar por contener una gran cantidad de azúcar?",
			"text_9-1-0": "Después de la cirugía, los suplementos vitamínicos no son esenciales, ya que obtendrá todas las vitaminas y minerales que necesita sólo de los alimentos",
			"text_9-1-1": "El hierro ayuda con:",
			"text_9-1-2": "Cuando elija vitaminas, asegúrese de que son:",
			"text_9-1-3": "El suplemento o suplementos que todo paciente necesita tomar después de la cirugía incluyen:",
			"text_9-1-4": "¿Con cuántas horas de diferencia del citrato de calcio debe tomarse el multivitamínico?",
			"text_10-1-0": "Lo más importante que puede hacer para dar tiempo a que su estómago se cure y evitar complicaciones es seguir la progresión de la dieta prescrita por su cirujano",
			"text_10-1-1": "La primera etapa en la progresión de la dieta es",
			"text_10-1-2": "Un ejemplo de alimento en puré es",
			"text_10-1-3": "¿Qué alimentos deben evitarse en una dieta regular?",
			"text_10-2-0": "Si experimenta náuseas con el agua, pruebe",
			"text_10-2-1": "Debe evitar el alcohol, porque",
			"text_10-2-2": "Para elegir mejor al hacer la compra, haga todo lo siguiente <emphasis>excepto</emphasis>:",
			"text_10-2-3": "Cuando coma en un restaurante,",
			"text_10-2-4": "Si siente que la comida se le queda atascada, beba algo para ayudarla a pasar",
			"text_11-1-0": "El objetivo de la cirugía de pérdida de peso es prosperar en todos los sentidos <emphasis>excepto</emphasis>",
			"text_11-1-1": "La ansiedad y la depresión pueden ser comunes en el postoperatorio",
			"text_11-1-2": "Los pacientes sometidos a cirugía de pérdida de peso pueden correr el riesgo de:",
			"text_11-1-3": "Una razón por la que algunos pacientes experimentan depresión tras la cirugía es",
			"text_11-2-0": "Las investigaciones han demostrado que la responsabilidad y el apoyo continuos marcan la diferencia entre la pérdida de peso temporal y la permanente",
			"text_11-2-1": "Ejemplos de alguien en su vida que sabotea su pérdida de peso incluyen todos los siguientes <emphasis>excepto</emphasis>:",
			"text_11-2-2": "Un buen sistema de apoyo es alguien que está dispuesto a",
			"text_11-2-3": "Una buena forma de determinar si ha tenido éxito después de la cirugía es comparar su pérdida de peso con la de otra persona que se haya sometido a la misma cirugía",
			"text_11-3-0": "Para hacer cambios sostenibles en su estilo de vida, necesita formar nuevos hábitos",
			"text_11-3-1": "La mejor manera de formar nuevos hábitos incluye",
			"text_11-3-2": "Un ejemplo de objetivo mensurable es",
			"text_11-3-3": "Todos los siguientes son ejemplos de un objetivo alcanzable <emphasis>excepto</emphasis>:",
			"text_11-3-4": "Es muy posible formar buenos hábitos de la noche a la mañana",
			"text_12-1-0": "¿Cuáles son las razones por las que la cirugía de pérdida de peso <emphasis>no</emphasis> es la vía fácil?",
			"text_12-1-1": "Todo lo siguiente es cierto con respecto a la cirugía de pérdida de peso <emphasis>excepto</emphasis>:",
			"text_12-1-2": "Tras la cirugía de pérdida de peso, sentirá que pasa hambre todo el tiempo",
			"text_12-1-3": "Tras el período de adaptación inicial, podrá disfrutar de todo lo siguiente <emphasis>excepto</emphasis>:",
			"text_12-2-0": "El mejor combustible para perder peso es",
			"text_12-2-1": "Para perder peso y estar sano, debe",
			"text_12-2-2": "Prestar atención a las proteínas y no al recuento de calorías es una de las claves más importantes para perder peso",
			"text_12-2-3": "Para formar hábitos saludables a largo plazo, debería",
			"text_12-3-0": "Los sentimientos comunes que impulsan a los pacientes a someterse a una cirugía de pérdida de peso incluyen todos los siguientes <emphasis>excepto</emphasis>:",
			"text_12-3-1": "Algunos ejemplos de objetivos para el futuro son",
			"text_12-3-2": "Los objetivos deben ser",
			"text_12-3-3": "Usted se ha creado unos objetivos. Este programa le ha dado lo que necesita para alcanzarlos.",
			"text_12-3-4": "Es esencial contar con buenos motivadores y apoyo para alcanzar sus objetivos."
		},
		"answerDetails": {
			"text": "Opción desconocida. Póngase en contacto con el administrador de su programa.",
			"text_1-2-6-0": "A: Una autoimagen negativa",
			"text_1-2-6-1": "B: Experimentar discriminación",
			"text_1-2-6-2": "C: Aislamiento social",
			"text_1-2-6-3": "D: Menor calidad de vida",
			"text_1-2-6-4": "E: Susceptibilidad a la depresión",
			"text_1-2-6-5": "F: Todas las anteriores",
			"text_1-2-7-0": "A: Enfermedad pulmonar (ejemplo: apnea obstructiva del sueño)",
			"text_1-2-7-1": "B: Enfermedad hepática (ejemplo: EHNA (enfermedad del hígado graso no alcohólico))",
			"text_1-2-7-2": "C: Anomalías ginecológicas (ejemplo: SOP (síndrome de ovario poliquístico))",
			"text_1-2-7-3": "D: Enfermedad coronaria",
			"text_1-2-7-4": "E: Todas las anteriores",
			"text_1-2-8-0": "A: IMC > 15 kg/m²",
			"text_1-2-8-1": "B: IMC > 20 kg/m²",
			"text_1-2-8-2": "C: IMC > 25 kg/m²",
			"text_1-2-8-3": "D: IMC > 30 kg/m²",
			"text_1-2-9-0": "A: Aumenta su riesgo de cáncer",
			"text_1-2-9-1": "B: Reduce el riesgo de muerte por diabetes tipo 2",
			"text_1-2-9-2": "C: Provoca dolor articular",
			"text_1-2-9-3": "D: Eleva el riesgo de mortalidad prematura",
			"text_2-1-0-0": "A: Pone en marcha su sistema inmunológico",
			"text_2-1-0-1": "B: Reducción del estrés",
			"text_2-1-0-2": "C: Potencia la energía",
			"text_2-1-0-3": "D: Mejora el estado de ánimo",
			"text_2-1-0-4": "E: Todas las anteriores",
			"text_2-1-1-0": "A: El ejercicio le ayuda a perder una cantidad significativa de peso",
			"text_2-1-1-1": "B: El ejercicio le ayuda a mantener su peso",
			"text_2-1-1-2": "C: El ejercicio le hace ganar mucho peso",
			"text_2-1-1-3": "D: El ejercicio no influye en su peso",
			"text_2-1-2-0": "A: Verdadero",
			"text_2-1-2-1": "B: Falso",
			"text_2-1-3-0": "A: Haga el doble al día siguiente",
			"text_2-1-3-1": "B: Renunciar para siempre",
			"text_2-1-3-2": "C: No se exija demasiado y siga su plan para el día siguiente",
			"text_2-1-3-3": "D: Saltarse una comida",
			"text_2-1-4-0": "A: Siga lo que hace su amigo",
			"text_2-1-4-1": "B: Averigüe qué es lo que mejor se adapta a su vida y a sus objetivos actuales de forma física/salud",
			"text_2-1-4-2": "C: Haga lo que sea más insoportable",
			"text_2-1-4-3": "D: Pruebe la moda más reciente",
			"text_2-1-5-0": "A: Divertidos",
			"text_2-1-5-1": "B: Desafiantes",
			"text_2-1-5-2": "C: Sostenibles",
			"text_2-1-5-3": "D: Adaptados a un estilo de vida",
			"text_2-1-5-4": "E: Todas las anteriores",
			"text_3-1-0-0": "A: Perder tanto peso como sea posible",
			"text_3-1-0-1": "B: Encontrar la medicación adecuada para ayudarle a perder peso",
			"text_3-1-0-2": "C: Lograr un peso saludable y mantenerlo el resto de su vida",
			"text_3-1-0-3": "D: Desarrollar la fuerza de voluntad para dominar una lista de reglas dietéticas",
			"text_3-1-1-0": "A: Verdadero",
			"text_3-1-1-1": "B: Falso",
			"text_3-1-2-0": "A: La mayoría de las dietas no son sostenibles",
			"text_3-1-2-1": "B: Las dietas a menudo omiten dar las razones que hay detrás de sus reglas",
			"text_3-1-2-2": "C: En algún momento, todas las dietas acaban",
			"text_3-1-2-3": "D: Muchas dietas establecen expectativas poco realistas que dejan a la gente desanimada",
			"text_3-1-2-4": "E: Todas las anteriores",
			"text_3-1-3-0": "A: Encontrar una dieta de moda que funcione mejor para usted",
			"text_3-1-3-1": "B: Admitir que tiene un problema",
			"text_3-1-3-2": "C: Poseer el autocontrol para no recaer nunca",
			"text_3-1-3-3": "D: Adquirir los conocimientos y las herramientas para perder peso y mantener un estilo de vida saludable",
			"text_3-1-4-0": "A: Problemas estomacales",
			"text_3-1-4-1": "B: Nerviosismo",
			"text_3-1-4-2": "C: Palpitaciones",
			"text_3-1-4-3": "D: Aumento del apetito",
			"text_3-1-5-0": "A: Verdadero",
			"text_3-1-5-1": "B: Falso",
			"text_3-2-0-0": "A: Dietas de moda",
			"text_3-2-0-1": "B: Medicinas mágicas",
			"text_3-2-0-2": "C: Medicamentos para adelgazar",
			"text_3-2-0-3": "D: El consejo de  “comer menos” y “hacer más ejercicio”",
			"text_3-2-0-4": "E: Mejorar su estilo de vida y su relación con la comida",
			"text_3-2-1-0": "A: Ejercicio",
			"text_3-2-1-1": "B: Cirugía de pérdida de peso",
			"text_3-2-1-2": "C: Intentar nuevas dietas de moda",
			"text_3-2-1-3": "D: Una nueva mentalidad",
			"text_3-2-1-4": "E: Una nueva relación con la comida",
			"text_3-2-2-0": "A: Empezar a seguir una dieta de conteo de calorías",
			"text_3-2-2-1": "B: Empezar a tomar pastillas para adelgazar",
			"text_3-2-2-2": "C: No volver a comer carne nunca más",
			"text_3-2-2-3": "D: Seguir trabajando en los cambios de estilo de vida y en su relación con la comida",
			"text_3-2-2-4": "E: Ninguna de las anteriores",
			"text_3-2-3-0": "A: Divertidos",
			"text_3-2-3-1": "B: Desafiantes",
			"text_3-2-3-2": "C: Sostenibles",
			"text_3-2-3-3": "D: Adaptados a un estilo de vida",
			"text_3-2-3-4": "E: Todas las anteriores",
			"text_3-2-4-0": "A: Actitud",
			"text_3-2-4-1": "B: Emociones",
			"text_3-2-4-2": "C: Hábitos",
			"text_3-2-4-3": "D: Todas las anteriores",
			"text_3-2-4-4": "E: Ninguna de las anteriores",
			"text_3-2-5-0": "A: No se puede medir en la báscula",
			"text_3-2-5-1": "B: Sólo se consiguen después del primer año",
			"text_3-2-5-2": "C: Son personales y pueden no reflejar el número que marca la báscula",
			"text_3-2-5-3": "D: Son pocos",
			"text_3-2-5-4": "E: A y C",
			"text_3-2-5-5": "F: Ninguna de las anteriores",
			"text_3-3-0-0": "A: Verdadero",
			"text_3-3-0-1": "B: Falso",
			"text_3-3-1-0": "A: Disminuir el riesgo de muerte prematura en un 30-40%.",
			"text_3-3-1-1": "B: Ayudarle a desarrollar una nueva mentalidad",
			"text_3-3-1-2": "C: Ayudarle a mantenerse sano y a no engordar",
			"text_3-3-1-3": "D: Prevenir las enfermedades relacionadas con la obesidad",
			"text_3-3-2-0": "A: Diabetes mellitus tipo II",
			"text_3-3-2-1": "B: Apnea obstructiva del sueño",
			"text_3-3-2-2": "C: Enfermedades cardiacas",
			"text_3-3-2-3": "D: Ciertos tipos de cáncer",
			"text_3-3-2-4": "E: Todas las anteriores",
			"text_3-3-3-0": "A: Reducir el apetito",
			"text_3-3-3-1": "B: Aumentar la sensación de saciedad",
			"text_3-3-3-2": "C: Facilitar la quema de más calorías",
			"text_3-3-3-3": "D: Todas las anteriores",
			"text_4-1-0-0": "A: La comida es el enemigo",
			"text_4-1-0-1": "B:La comida no está hecha para disfrutarla",
			"text_4-1-0-2": "C: La comida es combustible",
			"text_4-1-0-3": "D: La comida es algo que se come cuando se está aburrido",
			"text_4-1-1-0": "A: Proteínas, grasas y carbohidratos",
			"text_4-1-1-1": "B: Lo que da energía",
			"text_4-1-1-2": "C: Lo que más necesita en su dieta",
			"text_4-1-1-3": "D: Los que están presentes en la mayoría de los alimentos que consume",
			"text_4-1-1-4": "E: Todas las anteriores",
			"text_4-1-2-0": "A: Proteína",
			"text_4-1-2-1": "B: Vitaminas y minerales",
			"text_4-1-2-2": "C: Carbohidratos",
			"text_4-1-2-3": "D: Agua y fibra",
			"text_4-1-2-4": "E: B y D",
			"text_4-1-3-0": "A: Verdadero",
			"text_4-1-3-1": "B: Falso",
			"text_4-2-0-0": "A: Verdadero",
			"text_4-2-0-1": "B: Falso",
			"text_4-2-1-0": "A: Es la opción más saludable disponible",
			"text_4-2-1-1": "B: Es bueno para usted",
			"text_4-2-1-2": "C: La grasa ha sido sustituida por cosas que no son buenas para usted",
			"text_4-2-1-3": "D: Tiene menos calorías y menos ingredientes nocivos",
			"text_4-2-2-0": "A: Si está etiquetado como dietético o bajo en calorías",
			"text_4-2-2-1": "B: Si la información nutricional dice que tiene cero grasa",
			"text_4-2-2-2": "C: Si la lista de ingredientes tiene pocos ingredientes y parece nutritiva",
			"text_4-2-2-3": "D: Si el vendedor de la tienda dice que es bueno para usted",
			"text_4-2-3-0": "A: Azucar",
			"text_4-2-3-1": "B: Conservantes",
			"text_4-2-3-2": "C: Aditivos",
			"text_4-2-3-3": "D: Todas las anteriores",
			"text_4-2-3-4": "E: Ninguna de las anteriores",
			"text_5-1-0-0": "A: Energía para que la utilice cuando la necesite",
			"text_5-1-0-1": "B: Grasa",
			"text_5-1-0-2": "C: No se almacena en absoluto",
			"text_5-1-0-3": "D: Músculo",
			"text_5-1-1-0": "A: Los artículos con azúcar añadido deben reducirse al mínimo o evitarse",
			"text_5-1-1-1": "B: Debe limitarse a un postre al día",
			"text_5-1-1-2": "C: No es tan malo",
			"text_5-1-1-3": "D: Si hace ejercicio, puede quemar el exceso de azúcar que come",
			"text_5-1-2-0": "A: Lo que hace que se produzca más insulina en su cuerpo",
			"text_5-1-2-1": "B: Lo que hace que sus células grasas aumenten",
			"text_5-1-2-2": "C: Toxico",
			"text_5-1-2-3": "D: La causa número uno de la obesidad",
			"text_5-1-2-4": "E: Todas las anteriores",
			"text_5-1-3-0": "A: Verdadero",
			"text_5-1-3-1": "B: Falso",
			"text_5-2-0-0": "A: Verdadero",
			"text_5-2-0-1": "B: Falso",
			"text_5-2-1-0": "A: El pan, porque le da energía",
			"text_5-2-1-1": "B: El huevo, porque contiene grasas saludables y proteínas magras",
			"text_5-2-1-2": "C: Ambos son buenos para la salud e igualmente nutritivos",
			"text_5-2-1-3": "D: Ninguna de las anteriores",
			"text_5-2-2-0": "A: No es una ciencia exacta",
			"text_5-2-2-1": "B: No todas las calorías son iguales",
			"text_5-2-2-2": "C: No es sostenible",
			"text_5-2-2-3": "D: Las calorías no le informan sobre la nutrición de los alimentos, que es más importante",
			"text_5-2-2-4": "E: Todas las anteriores",
			"text_5-2-3-0": "A: Verdadero",
			"text_5-2-3-1": "B: Falso",
			"text_5-3-0-0": "A: Contenido de azúcar",
			"text_5-3-0-1": "B: Contenido de grasa",
			"text_5-3-0-2": "C: Nivel de sodio",
			"text_5-3-0-3": "D: Tamaño de la ración",
			"text_5-3-0-4": "E: Contenido de proteina",
			"text_5-3-1-0": "A: Grasas saturadas",
			"text_5-3-1-1": "B: Grasas trans",
			"text_5-3-1-2": "C: Grasas insaturadas",
			"text_5-3-1-3": "D: Ninguna de las anteriores — todas las grasas son buenas para usted",
			"text_5-3-2-0": "A: Grasas",
			"text_5-3-2-1": "B: Sodio",
			"text_5-3-2-2": "C: Calorías",
			"text_5-3-2-3": "D: Azucar",
			"text_5-3-2-4": "E: Proteína",
			"text_5-3-3-0": "A: Grasa",
			"text_5-3-3-1": "B: Carbohidratos",
			"text_5-3-3-2": "C: Proteína",
			"text_5-3-3-3": "D: Fibra",
			"text_5-3-3-4": "E: Ninguna de las anteriores",
			"text_6-1-0-0": "A: Sentirse lleno",
			"text_6-1-0-1": "B: Tener energía",
			"text_6-1-0-2": "C: Proteger de la pérdida de masa muscular",
			"text_6-1-0-3": "D: Quemar grasa",
			"text_6-1-0-4": "E: Todas las anteriores",
			"text_6-1-1-0": "A: Verdadero",
			"text_6-1-1-1": "B: Falso",
			"text_6-1-2-0": "A: Carnes magras, aves de corral y pescado",
			"text_6-1-2-1": "B: Cereales integrales",
			"text_6-1-2-2": "C: Frutas y vegetales",
			"text_6-1-2-3": "D: Frutos secos y semillas",
			"text_6-1-3-0": "A: 25%",
			"text_6-1-3-1": "B: 40%",
			"text_6-1-3-2": "C: 75%",
			"text_6-1-3-3": "D: 100%",
			"text_6-1-4-0": "A: Verdadero",
			"text_6-1-4-1": "B: Falso",
			"text_6-2-0-0": "A: Simple",
			"text_6-2-0-1": "B: Complejo",
			"text_6-2-1-0": "A: Granos",
			"text_6-2-1-1": "B: Vegetales",
			"text_6-2-1-2": "C: Frutas",
			"text_6-2-1-3": "D: Cereales integrales",
			"text_6-2-1-4": "E: Todas las anteriores",
			"text_6-2-2-0": "A: Contienen vitaminas y minerales",
			"text_6-2-2-1": "B: Dan energía a su cuerpo",
			"text_6-2-2-2": "C: Son más fáciles de digerir",
			"text_6-2-2-3": "D: Contienen fibra",
			"text_6-2-2-4": "E: Le mantienen saciado durante más tiempo",
			"text_6-2-3-0": "A: Restar los carbohidratos de las proteínas",
			"text_6-2-3-1": "B: Restar el azúcar añadido del total de carbohidratos",
			"text_6-2-3-2": "C: Restar los gramos de fibra dietética de los gramos de carbohidratos",
			"text_6-2-3-3": "D: Añadir carbohidratos a la fibra dietética",
			"text_6-2-3-4": "E: Ninguna de las anteriores",
			"text_6-2-4-0": "A: 100 gramos",
			"text_6-2-4-1": "B: 20 gramos",
			"text_6-2-4-2": "C: 50 gramos",
			"text_6-2-4-3": "D: 15 gramos",
			"text_6-2-4-4": "E: No comer nada de carbohidratos",
			"text_6-3-0-0": "A: Grasas insaturada",
			"text_6-3-0-1": "B: Grasas saturada",
			"text_6-3-0-2": "C: Todas las grasas",
			"text_6-3-0-3": "D: Grasas trans",
			"text_6-3-0-4": "E: Ninguna de las anteriores",
			"text_6-3-1-0": "A: Carne, huevos y leche",
			"text_6-3-1-1": "B: Papas fritas y alimentos procesados",
			"text_6-3-1-2": "C: Frutos secos, semillas y aceite de oliva",
			"text_6-3-1-3": "D: Dulces, galletas y pasteles",
			"text_6-3-1-4": "E: Ninguna de las anteriores",
			"text_6-3-2-0": "A: Disminuir el colesterol malo",
			"text_6-3-2-1": "B: Protejer su corazón",
			"text_6-3-2-2": "C: Reducir la inflamación",
			"text_6-3-2-3": "D: Mantenga su piel y su cabello suaves",
			"text_6-3-2-4": "E: Todas las anteriores",
			"text_6-3-3-0": "A: Crema",
			"text_6-3-3-1": "B: Tocineta",
			"text_6-3-3-2": "C: Mantequilla",
			"text_6-3-3-3": "D: Queso entero",
			"text_6-3-3-4": "E: Todas las anteriores",
			"text_7-1-0-0": "A: 5-6 onzas por comida",
			"text_7-1-0-1": "B: 8-9 onzas por comida",
			"text_7-1-0-2": "C: 3-4 onzas por comida",
			"text_7-1-0-3": "D: 2-3 onzas por comida",
			"text_7-1-1-0": "A: Medir todos sus alimentos",
			"text_7-1-1-1": "B: Pesar todos sus alimentos",
			"text_7-1-1-2": "C: Usar un plato más pequeño",
			"text_7-1-1-3": "D: Beber mucha agua con la comida",
			"text_7-1-2-0": "A: Regla 30/30/40 (30% verduras/30% carbohidratos simples/40% proteínas)",
			"text_7-1-2-1": "B: Regla 25/50/25 (25% de proteínas magras primero/50% de verduras sin almidón/25% de carbohidratos complejos)",
			"text_7-1-2-2": "C: Regla 50/50 (50% carbohidratos complejos/50% proteínas)",
			"text_7-1-2-3": "D: Regla 75/25 (75% carbohidratos simples/25% verduras)",
			"text_7-1-3-0": "A: Verdadero",
			"text_7-1-3-1": "B: Falso",
			"text_7-1-4-0": "A: Ser consumidas primero",
			"text_7-1-4-1": "B: Ser evitadas",
			"text_7-1-4-2": "C: Consumirse con moderación",
			"text_7-1-4-3": "D: Ser lo único que consuma en su dieta",
			"text_7-1-5-0": "A: Carbohidratos",
			"text_7-1-5-1": "B: Vegetales",
			"text_7-1-5-2": "C: Proteína",
			"text_7-1-5-3": "D: Puede comer primero lo que quiera",
			"text_7-2-0-0": "A: Reducir su energía",
			"text_7-2-0-1": "B: Dificultar el ejercicio",
			"text_7-2-0-2": "C: Aumentar el riesgo de diabetes",
			"text_7-2-0-3": "D: Conducir a comer en exceso y a darse atracones poco saludables",
			"text_7-2-0-4": "E: Todas las anteriores",
			"text_7-2-1-0": "A: Comer 3 veces al día",
			"text_7-2-1-1": "B: Comer snacks siempre que tenga hambre",
			"text_7-2-1-2": "C: Limitar las veces que pica a lo largo del día",
			"text_7-2-1-3": "D: Planificar con antelación",
			"text_7-2-2-0": "A: Eliminar por completo los snacks",
			"text_7-2-2-1": "B: Coma sólo un snack al día a la misma hora todos los días",
			"text_7-2-2-2": "C: Coma los mismos snacks todos los días",
			"text_7-2-2-3": "D: Planificar con antelación snacks equilibrados",
			"text_7-2-2-4": "E: Ninguna de las anteriores",
			"text_7-2-3-0": "A: Nunca lo haga",
			"text_7-2-3-1": "B: Comer en un sitio donde no sirvan postre",
			"text_7-2-3-2": "C: Mirar el menú con antelación para decidir lo que quiere",
			"text_7-2-3-3": "D: Permítase comer al menos una vez a la semana fuera de casa",
			"text_7-2-3-4": "E: Ninguna de las anteriores",
			"text_7-2-4-0": "A: Verdadero",
			"text_7-2-4-1": "B: Falso",
			"text_8-1-0-0": "A: Verdadero",
			"text_8-1-0-1": "B: Falso",
			"text_8-1-1-0": "A: Llevar una botella de agua a todas partes",
			"text_8-1-1-1": "B: Beber de 6 a 8 onzas cada hora",
			"text_8-1-1-2": "C: Tomar muchas bebidas con cafeína",
			"text_8-1-1-3": "D: Procurar ingerir 64 onzas de líquido sin azúcar cada día",
			"text_8-1-2-0": "A: 48 onzas",
			"text_8-1-2-1": "B: 32 onzas",
			"text_8-1-2-2": "C: 24 onzas",
			"text_8-1-2-3": "D: 6 onzas",
			"text_8-1-2-4": "E: > 64 onzas",
			"text_8-1-3-0": "A: Jugo",
			"text_8-1-3-1": "B: Soda",
			"text_8-1-3-2": "C: Gatorade",
			"text_8-1-3-3": "D: Limonada",
			"text_8-1-3-4": "E: Todas las anteriores",
			"text_9-1-0-0": "A: Verdadero",
			"text_9-1-0-1": "B: Falso",
			"text_9-1-1-0": "A: Energía",
			"text_9-1-1-1": "B: Focos",
			"text_9-1-1-2": "C: Inmunidad",
			"text_9-1-1-3": "D: Función cardiaca",
			"text_9-1-1-4": "E: Todas las anteriores",
			"text_9-1-2-0": "A: Chicles",
			"text_9-1-2-1": "B: Vitaminas para hombres",
			"text_9-1-2-2": "C: Vitaminas para mayores",
			"text_9-1-2-3": "D: Todas las anteriores son aceptables",
			"text_9-1-2-4": "E: Ninguna de las anteriores es aceptable",
			"text_9-1-3-0": "A: Zinc",
			"text_9-1-3-1": "B: Multivitamínico",
			"text_9-1-3-2": "C: Biotina",
			"text_9-1-3-3": "D: Citrato de calcio y vitamina D",
			"text_9-1-3-4": "E: B y D",
			"text_9-1-4-0": "A: 4 horas",
			"text_9-1-4-1": "B: 1 hora",
			"text_9-1-4-2": "C: 2 horas",
			"text_9-1-4-3": "D: 3 horas",
			"text_10-1-0-0": "A: Verdadero",
			"text_10-1-0-1": "B: Falso",
			"text_10-1-1-0": "A: Alimentos sólidos",
			"text_10-1-1-1": "B: Dieta a base de puré",
			"text_10-1-1-2": "C: Dieta liquida",
			"text_10-1-1-3": "D: Dieta de liquidos claros",
			"text_10-1-1-4": "E: Comidas suaves",
			"text_10-1-2-0": "A: Carne de charcutería",
			"text_10-1-2-1": "B: Una manzana",
			"text_10-1-2-2": "C: Comida de bebé",
			"text_10-1-2-3": "D: Brócoli bien cocido",
			"text_10-1-2-4": "E: Una pechuga de pollo cortada en trozos pequeños",
			"text_10-1-3-0": "A: Grasas saludables",
			"text_10-1-3-1": "B: Proteína magra",
			"text_10-1-3-2": "C: Almidones",
			"text_10-1-3-3": "D: Verduras sin almidón",
			"text_10-1-3-4": "E: Frutas frescas",
			"text_10-2-0-0": "A: Beberlo muy rápido para asegurarse de que la ingiere toda",
			"text_10-2-0-1": "B: Jugo de frutas en su lugar",
			"text_10-2-0-2": "C: Calentarla o beberla a temperatura ambiente",
			"text_10-2-0-3": "D: Tomar agua con gas y carbonatada",
			"text_10-2-1-0": "A: Aporta calorías vacías",
			"text_10-2-1-1": "B: Puede causar deshidratación",
			"text_10-2-1-2": "C: Puede agravar el estómago",
			"text_10-2-1-3": "D: Tiene un mayor riesgo de adicción al alcohol después de la cirugía",
			"text_10-2-1-4": "E: Todas las anteriores",
			"text_10-2-2-0": "A: Elegir alimentos de verdad",
			"text_10-2-2-1": "B: Compre sólo en los pasillos interiores",
			"text_10-2-2-2": "C: Limítese al exterior de la tienda",
			"text_10-2-2-3": "D: Elija alimentos con cinco o menos ingredientes",
			"text_10-2-3-0": "A: No pida bebida ni pan",
			"text_10-2-3-1": "B: Compartir una entrada con un amigo",
			"text_10-2-3-2": "C: Haga que le envuelvan la mitad de su comida para llevar antes incluso de empezar a comer",
			"text_10-2-3-3": "D: Planificar con antelación",
			"text_10-2-3-4": "E: Todas las anteriores",
			"text_10-2-4-0": "A: Verdadero",
			"text_10-2-4-1": "B: Falso",
			"text_11-1-0-0": "A: Mentalidad",
			"text_11-1-0-1": "B: Fisicamente",
			"text_11-1-0-2": "C: Emocionalmente",
			"text_11-1-0-3": "D: Todo lo anterior es necesario para prosperar",
			"text_11-1-1-0": "A: Verdadero",
			"text_11-1-1-1": "B: Falso",
			"text_11-1-2-0": "A: Trastornos alimenticios",
			"text_11-1-2-1": "B: Problemas en las relaciones",
			"text_11-1-2-2": "C: Nuevas adicciones",
			"text_11-1-2-3": "D: “Remordimiento del comprador” (arrepentirse de haberse operado)",
			"text_11-1-2-4": "E: Todas las anteriores",
			"text_11-1-3-0": "A: Pierden peso demasiado rápido",
			"text_11-1-3-1": "B: Tienen que comprar ropa nueva",
			"text_11-1-3-2": "C: Pierden mucho peso al principio, y con el tiempo se ralentiza o se estabiliza",
			"text_11-1-3-3": "D: Son capaces de hacer cosas que nunca antes habían podido hacer",
			"text_11-2-0-0": "A: Verdadero",
			"text_11-2-0-1": "B: Falso",
			"text_11-2-1-0": "A: Su jefe trayendo donas al trabajo",
			"text_11-2-1-1": "B: Su cónyuge comprando su helado favorito",
			"text_11-2-1-2": "C: Su compañero de trabajo animándole a caminar con ellos durante el almuerzo",
			"text_11-2-1-3": "D: Su hermana preparándole una torta para su cumpleaños",
			"text_11-2-2-0": "A: Escuchar",
			"text_11-2-2-1": "B: Reconfortarle",
			"text_11-2-2-2": "C: Hacerle responsable",
			"text_11-2-2-3": "D: Afirmar sus miedos",
			"text_11-2-2-4": "E: Todas las anteriores",
			"text_11-2-3-0": "A: Verdadero",
			"text_11-2-3-1": "B: Falso",
			"text_11-3-0-0": "A: Verdadero",
			"text_11-3-0-1": "B: Falso",
			"text_11-3-1-0": "A: Primero conociendo sus malos hábitos",
			"text_11-3-1-1": "B: Hacer que los objetivos sean medibles y alcanzables",
			"text_11-3-1-2": "C: Siendo realista",
			"text_11-3-1-3": "D: Gestionando las expectativas",
			"text_11-3-1-4": "E: Todas las anteriores",
			"text_11-3-2-0": "A: Comeré mejor",
			"text_11-3-2-1": "B: Haré más ejercicio",
			"text_11-3-2-2": "C: Me propondré dar 3.000 pasos diarios caminando en el trabajo",
			"text_11-3-2-3": "D: Comeré menos",
			"text_11-3-3-0": "A: Empezaré por caminar en la cinta durante 5 minutos cada día",
			"text_11-3-3-1": "B: Nunca he corrido, pero este año me apuntaré a un maratón",
			"text_11-3-3-2": "C: Bebo 3 refrescos al día y empezaré bebiendo sólo 2 refrescos al día",
			"text_11-3-3-3": "D: Siempre me salto el desayuno pero empezaré por tomar algo pequeño cada día",
			"text_11-3-4-0": "A: Verdadero",
			"text_11-3-4-1": "B: Falso",
			"text_12-1-0-0": "A: Es una fórmula: cirugía de pérdida de peso + cambiar su forma de entender y su relación con la comida + volverse más activo + estrategias de salud mental = <emphasis>éxito para toda la vida</emphasis>",
			"text_12-1-0-1": "B: Los resultados no están garantizados. La cantidad final de pérdida de peso es directamente proporcional a los esfuerzos del paciente.",
			"text_12-1-0-2": "C: La parte de la cirugía de pérdida de peso es la fase más sencilla de todo el proceso. Sin embargo, si no se cumplen todos los criterios de la fórmula, no tendrá éxito.",
			"text_12-1-0-3": "D: La obesidad es una enfermedad agresiva y mortal, y la cirugía para perder peso es el tratamiento más eficaz.",
			"text_12-1-0-4": "E: Todas las anteriores",
			"text_12-1-1-0": "A: El riesgo de muerte por cirugía bariátrica es aproximadamente el mismo que para la cirugía de la vesícula biliar.",
			"text_12-1-1-1": "B: Las tasas de mortalidad de la cirugía bariátrica han disminuido de forma constante a lo largo de los años; las tasas de mortalidad son ahora inferiores a una fracción de un porcentaje.",
			"text_12-1-1-2": "C: Más del 15% de los pacientes sufrirán un infarto durante la operación.",
			"text_12-1-1-3": "D: Es más arriesgado <emphasis>no</emphasis> someterse a una cirugía de pérdida de peso debido a las posibles complicaciones de salud asociadas a la obesidad.",
			"text_12-1-2-0": "A: Verdadero",
			"text_12-1-2-1": "B: Falso",
			"text_12-1-3-0": "A: Variedad de alimentos saludables",
			"text_12-1-3-1": "B: Alimentos ricos en proteínas",
			"text_12-1-3-2": "C: Muchos alimentos ricos en azúcar y grasa",
			"text_12-1-3-3": "D: Alimentos bajos en carbohidratos",
			"text_12-2-0-0": "A: Grasas trans",
			"text_12-2-0-1": "B: Proteinas magras",
			"text_12-2-0-2": "C: Carbohidratos",
			"text_12-2-0-3": "D: Fibra",
			"text_12-2-0-4": "E: Azucar",
			"text_12-2-1-0": "A: Omitir el desayuno si no tiene hambre",
			"text_12-2-1-1": "B: Comer tres veces al día aunque no tenga hambre",
			"text_12-2-1-2": "C: Merendar, picotear y comer con frecuencia para mantenerse satisfecho",
			"text_12-2-1-3": "D: Comer carbohidratos primero para obtener energía",
			"text_12-2-2-0": "A: Verdadero",
			"text_12-2-2-1": "B: Falso",
			"text_12-2-3-0": "A: Marcar el ritmo de su viaje para protegerse del agotamiento",
			"text_12-2-3-1": "B: Centrarse en arreglar su mentalidad",
			"text_12-2-3-2": "C: Conectarse con personas que le apoyan",
			"text_12-2-3-3": "D: Céntrese en su “<emphasis>porqué</emphasis>”",
			"text_12-2-3-4": "E: Todas las anteriores",
			"text_12-3-0-0": "A: Cansancio",
			"text_12-3-0-1": "B: Tristeza",
			"text_12-3-0-2": "C: Felicidad",
			"text_12-3-0-3": "D: Desesperanza",
			"text_12-3-1-0": "A: Poder salir en una foto sin sentirse cohibido",
			"text_12-3-1-1": "B: Caminar sin ayuda",
			"text_12-3-1-2": "C: Obtener un sueño reparador",
			"text_12-3-1-3": "D: Vivir una larga vida con las personas que ama",
			"text_12-3-1-4": "E: Todas las anteriores",
			"text_12-3-2-0": "A: Realistas",
			"text_12-3-2-1": "B: Muy desafiantes",
			"text_12-3-2-2": "C: Medibles",
			"text_12-3-2-3": "D: Desalentadores",
			"text_12-3-2-4": "E: A y C",
			"text_12-3-3-0": "A: Verdadero",
			"text_12-3-3-1": "B: Falso",
			"text_12-3-4-0": "A: Verdadero",
			"text_12-3-4-1": "B: Falso"
		}
	},
	"web": {
		"general": {
			"days": "{{count, number}} días",
			"days_one": "{{count, number}} día",
			"months": "{{count, number}} meses",
			"months_one": "{{count, number}} mes",

			"loadingMessage": "Cargando...",

			"saveButton": "Guardar",
			"cancelButton": "Cancelar",

			"headerLabel": "NewTri",
			"headerUserMenuLabel": "Usuario",
			"headerUserMenuOptionProfile": "Perfil",
			"headerUserMenuOptionAdminDashboard": "Panel de administración",
			"headerUserMenuOptionLogOut": "Cerrar sesión",

			"profileEmailAddressInput": "Dirección de correo electrónico",
			"profileFirstNameInput": "Nombre",
			"profileLastNameInput": "Apellido",
			"profileCellPhoneNumberInput": "Número de teléfono móvil",
			"profileDateOfBirthInput": "Fecha de nacimiento",
			"profileSexInput": "Genero",

			"calendarPreviousMonthButton": "Mes anterior",
			"calendarNextMonthButton": "Mes siguiente",

			"modalCloseLabel": "Cerrar",
			"confirmationModalConfirmButton": "Sí",
			"confirmationModalCancelButton": "No",

			"expandableAlertExpandLabel": "Ampliar",
			"expandableAlertCollapseLabel": "Contraer",

			"paceSelectOption": "$t(general.days, { \"count\": {{days}} }) ($t(general.months, { \"count\": {{months}} }))",

			"homeDashboardTab": "Panel de control",
			"homeVideoCourseTab": "Vídeo curso",
			"homePatientResourcesTab": "Recursos para el paciente",
			"homeSupportTab": "Soporte",

			"courseHeader": "Educación preoperatoria para pacientes de cirugía de pérdida de peso",
			"courseModuleAvailabilityMessage": "Este módulo estará disponible para usted {{date, datetime(month: long; day: numeric)}}.",
			"courseModuleAvailabilitySoonMessage": "Este módulo estará pronto a su disposición.",
			"courseModuleBeginButton": "Comenzar {{moduleName}}",
			"courseModuleContinueButton": "Continuar {{moduleName}}",
			"courseProgressMessage": "Progreso de mi curso {{progress, number(style: percent)}} completado",
			"courseCompletionHeader": "¡Felicidades por completar el curso NewTri!",

			"certificateDownloadLabel": "Descargar el certificado de aprobación",
			"certificateDownloadButton": "Descargar certificado",
			"certificateDownloadModalHeader": "Descargar certificado",
			"certificateDownloadModalMessage": "¿Qué le gustaría incluir en el certificado de aprobación? Siempre puede cambiar de opinión y generarlo de nuevo.",
			"certificateDownloadModalCoverLetterInput": "Carta de presentación — una explicación del programa NewTri dirigida a las compañías aseguradoras y otros agentes pagadores para contextualizar el resto del contenido del certificado.",
			"certificateDownloadModalCertificateOfCompletionInput": "Certificado de aprobación — el certificado oficial que indica la finalización del programa NewTri.",
			"certificateDownloadModalSummaryOfProgressInput": "Resumen del progreso — Gráficos de información de alto nivel que muestran los registros y las puntuaciones de los tests a lo largo de la duración del programa.",
			"certificateDownloadModalDetailedReportInput": "Informe detallado — todos los registros individuales de comida, ejercicio y peso, así como los resultados de la evaluación de las 25 clases.",
			"certificateDownloadModalDownloadButton": "Descargar",

			"patientResourcesMessage": "Estos enlaces son proporcionados por su Programa Bariátrico seleccionado. Al hacer clic en un enlace accederá a un sitio web de terceros, que no está gestionado por NewTri Health. No podemos garantizar la exactitud de ningún sitio web de terceros. Cuando siga el enlace, estará sujeto a la política de privacidad del sitio web de destino.",
			"patientResourcesDeleteButton": "borrar",

			"patientSupportMessage": "Si tiene dificultades técnicas con el sitio NewTri, póngase en contacto con <reference>support@newtrihealth.com</reference>.",

			"inactiveLogOutMessage": "Hemos notado su ausencia desde hace un rato. Para su protección, cerraremos automáticamente su sesión cuando se agote el tiempo indicado a continuación. Si sigue ahí, haga clic en “Permanecer conectado”.",
			"inactiveLogOutTitle": "¿Sigue allí?",
			"inactiveLogOutStayLoggedInButton": "Permanecer conectado",
			"inactiveLogOutLogOutButton": "Cerrar sesión"
		},
		"account": {
			"header": "Editar su perfil",
			"informationHeader": "Información de la cuenta",
			"membershipDateMessage": "Se hizo miembro full el {{date, datetime(dateStyle: long)}}.",
			"avatarLabel": "avatar de usuario",
			"completeProfileMessage": "Rellene su perfil a continuación.",

			"paymentMessage": "Para acceder al curso NewTri, realice el pago mediante el siguiente formulario.",
			"discountCodeMessage": "Si tiene un código de descuento, introdúzcalo aquí:",
			"oneTimePaymentOption": "Realice un único pago de {{amount, currency(USD)}} <highlight>(¡Un ahorro de {{discountAmount, currency(USD)}}!)</highlight>",
			"paymentPlanOption": "Realice {{installments, number}} pagos mensuales de {{amount, currency(USD)}}",
			"submitPaymentButton": "Enviar pago",
			"updatePaymentButton": "Actualizar pago",
			"payPalOptionMessage": "O pague con PayPal",
			"payPalPaymentDetailsMessage": "El plan de pago trimestral sólo está disponible para pagar con tarjeta de crédito. Se le cargará un pago de {{amount, currency(USD)}}.",
			"paymentError": "Ha habido un problema al procesar su pago. Póngase en contacto con soporte.",

			"saveProfileButton": "Guardar cambios",
			"cancelProfileChangesButton": "Cancelar",

			"billingHeader": "Facturación",
			"billingActivatedDateMessage": "Ha activado NewTri el {{date, datetime}}.",
			"billingActivatedDateAndChangeMessage": "Ha activado NewTri el {{date, datetime}}. Cobramos {{amount, currency(USD)}}.",
			"billingActivatedDateAndChangeMessage_stripe": "Ha activado NewTri el {{date, datetime}}. Cobramos {{amount, currency(USD)}} a la tarjeta de crédito que termina en {{cardLast4Digits}}.",
			"billingActivatedDateAndChangeMessage_paypal": "Ha activado NewTri el {{date, datetime}}. Cobramos {{amount, currency(USD)}} de su cuenta PayPal.",
			"subscriptionExpiredError": "Su método de pago registrado ha sido rechazado. Por favor, actualice su información de pago.",

			"credentialsHeader": "Credenciales de la cuenta",
			"changeEmailAddressButton": "Cambiar dirección de correo electrónico",
			"emailAddressChangeRequestMessage": "Correo de verificación enviado. Siga las instrucciones del correo electrónico para terminar de actualizar su dirección de correo electrónico.",
			"currentPasswordInput": "Contraseña actual",
			"newPasswordInput": "Nueva contraseña",
			"changePasswordButton": "Cambiar contraseña",
			"passwordChangeSuccessMessage": "¡Su nueva contraseña ha sido establecida!",

			"mobileAppRecommendationMessage": "Le recomendamos que utilice nuestras aplicaciones móviles:",
			"appleAppStoreLabel": "App Store de Apple",
			"googlePlayStoreLabel": "Tienda Google Play"
		},
		"signup": {
			"header": "Cree su cuenta NewTri:",
			"instructionsMessage": "Se le enviará un correo electrónico de confirmación a esta dirección. Siga las instrucciones del correo electrónico para continuar configurando su cuenta.",
			"awaitingConfirmationMessage": "Se ha enviado un correo electrónico de confirmación a {{emailAddress}}. Siga las instrucciones del correo electrónico para continuar configurando su cuenta.",
			"cellPhoneNumberWarningMessage": "Pueden aplicarse tarifas de mensajes y datos.",
			"passwordInput": "Contraseña",
			"passwordRequirementsMessage": "Las contraseñas deben tener al menos 8 caracteres y constar de al menos uno de cada uno de los siguientes elementos: una letra mayúscula, una letra minúscula, un número y un carácter especial.",
			"providerInput": "Seleccionar práctica",
			"providerInputNoneOption": "Empezar NewTri sin una práctica",
			"surgeonInput": "Seleccionar cirujano",
			"acceptTermsAndConditionsInput": "He leído y entendido los <reference>Términos y condiciones</reference>",
			"acceptPrivacyPolicyInput": "He leído y entendido las <reference>políticas de privacidad</reference>",
			"submitButton": "Registrarse",
			"linkExpiredError": "El enlace de invitación ya no es válido. Póngase en contacto con su proveedor para obtener un nuevo enlace.",
			"genericError": "Algo ha ido mal. Por favor, inténtelo de nuevo."
		},
		"dashboard": {
			"editTodayButton": "Editar hoy",
			"saveSuccessMessage": "Sus cambios se han guardado.",
			"saveError": "No se ha podido guardar. Por favor, inténtelo de nuevo.",

			"exerciseHeader": "Registro de ejercicios",
			"exerciseEntryMessage": "¿Hizo ejercicio el <emphasis>{{date, datetime(month: long; day: numeric)}}</emphasis>?",
			"exerciseEntryTodayMessage": "¿Ha hecho ejercicio <emphasis>hoy</emphasis>?",
			"exerciseOption_no": "No",
			"exerciseOption_yes": "Sí",
			"exerciseDetailsMessage": "Añada detalles sobre su día:",
			"exerciseActivitiesInput": "Actividades de ejercicio",
			"exerciseDurationInput": "Duración del ejercicio",

			"foodHeader": "Registro de comidas",
			"foodEntryMessage": "¿Cómo se siente acerca de lo que comió el <emphasis>{{date, datetime(month: long; day: numeric)}}</emphasis>?",
			"foodEntryTodayMessage": "¿Cómo se siente acerca de lo que comió <emphasis>hoy</emphasis>?",
			"foodDetailsMessage": "Añada detalles sobre su día:",
			"foodMealTimeInput": "Hora de comer",
			"foodMealDescriptionInput": "¿Qué ha comido?",
			"foodFrequencyEncouragementMessage": "¡Ha registrado su comida 5 días esta semana! ¡Buen trabajo!",
			"foodGoodRatingEncouragementMessage": "<paragraph>¡Parece que ha estado comiendo muy bien esta semana! Así se hace!</paragraph><paragraph>Construir y mantener unos hábitos alimenticios saludables ahora marcará toda la diferencia en el mundo durante el resto de su camino hacia la pérdida de peso.</paragraph>",

			"weightHeader": "Registro de peso",
			"weightEntryMessage": "¿Cuánto pesaba el <emphasis>{{date, datetime(month: long; day: numeric)}}</emphasis>?",
			"weightEntryTodayMessage": "Cuánto pesó <emphasis>hoy</emphasis>?",
			"weightWithingsConnectButton": "Conectarse a Withings",
			"weightWithingsDisconnectButton": "Desconectarse de Withings",
			"weightWithingsReconnectButton": "Reconectarse a Withings",
			"weightWithingsConnectionError": "NewTri ha perdido la conexión con su cuenta Withings. <action>Haga clic aquí para volver a conectarla</action>.",
			"weightWithingsScaleError": "No tiene una báscula conectada a su cuenta Withings.",
			"weightWithingsGeneralError": "Hubo un problema de comunicación con Withings.",
			"weightEncouragementMessage": "<paragraph>¡No deje de registrar su peso y ejercicio! Incluso si está desanimado, es importante que siga registrando estas cosas para que pueda hacer un seguimiento preciso de su progreso y revisar los hábitos de cerca con su programa de cirugía.</paragraph><paragraph>Parece que ha tenido un pequeño revés con su peso. No se desanime y no se rinda.</paragraph><paragraph>Asegúrese de seguir registrando su peso y sus ejercicios — esto ayudará a su cirujano a hacer un seguimiento de sus hábitos y progresos, para que puedan ayudarle mejor a seguir adelante.</paragraph>",

			"quizAverageHeader": "Promedio de la prueba"
		},
		"course": {
			"availableDateMessage": "Disponible: {{date, datetime(dateStyle: long)}}",
			"releasedDateMessage": "Publicado: {{date, datetime(dateStyle: long)}}",
			"paymentDeclinedError": "Su método de pago registrado ha sido rechazado. Por favor, visite su <reference>Perfil</reference> para actualizar su información de pago",
			"paymentMissingError": "Se requiere el pago para ver las lecciones. Por favor visite su <reference>Perfil</reference> para actualizar su información de pago.",
			"lessonSubHeader": "Clase {{lessonNumber}}",
			"lessonVideoTab": "Video",
			"lessonKeyFactsTab": "Datos clave",
			"lessonArticleTab": "Artículo",
			"lessonQuizTab": "Cuestionario",

			"lessonQuizUnavailableMessage": "Por favor, vea el vídeo para desbloquear el cuestionario.",
			"lessonQuizExplanationMessage": "La siguiente evaluación pondrá a prueba su comprensión de los materiales proporcionados esta semana. Una vez que comience la evaluación dispondrá de 10 minutos para completarla. Sólo podrá realizar esta evaluación una vez.",
			"lessonQuizLoadError": "Se ha producido un error al cargar las preguntas. Por favor, actualice esta página.",
			"lessonQuizStartMessage": "En cuanto esté listo/a, pulse “Iniciar” a continuación.",
			"lessonQuizStartButton": "Iniciar",
			"lessonQuizAnswerSaveError": "Ha habido un problema al guardar sus respuestas. Por favor, vuelva a cargar la página e inténtelo de nuevo.",
			"lessonQuizSubmitButton": "Enviar",
			"lessonQuizResultsHeader": "Resultados de la evaluación",
			"lessonQuizFullScoreEncouragementMessage": "Ha obtenido una puntuación del 100% en su cuestionario, ¡así se hace! ¡Siga trabajando así de bien!",
			"lessonQuizLowScoreEncouragementMessage": "<paragraph>Parece que lo ha pasado mal con el cuestionario de comprensión de esta clase. No se preocupe, a veces pasa.</paragraph><paragraph>Si se siente atascado o necesita ayuda para comprender la información, siempre puede ponerse en contacto con su programa de cirugía — ¡estarán encantados de ayudarle!</paragraph><paragraph>Y asegúrese de revisar siempre la infografía de los hechos clave y la información complementaria de cada clase, antes de realizar el cuestionario.</paragraph>",
			"lessonQuizResultsMessage": "Ha respondido correctamente a {{correctAnswerCount}} de {{questionCount}} preguntas ({{scorePercent, number(style: percent)}})."
		}
	},
	"mobile": {
		"general": {
			"loadingLabel": "cargando",
			"externalLinkHint": "abrir en una nueva ventana",
			"datePickerHint": "abrir calendario",
			"optionPickerCloseButton": "Cerrar",
			"textInputFieldUnitFormat": "{{value}} {{unit}}",
			"genericErrorMessage": "¡Algo salió mal!",
			"genericErrorRetryButton": "Vuelva a intentarlo",
			"genericErrorShowDetailsButton": "Mostrar detalles",
			"genericErrorHideDetailsButton": "Ocultar detalles",
			"unauthorizedErrorMessage": "Sesión expirada. Por favor, inicie sesión de nuevo.",
			"textFieldShowSecureTextButton": "Mostrar {{fieldLabel}}",
			"textFieldHideSecureTextButton": "Ocultar {{fieldLabel}}",

			"passwordRequirementsHeader": "Requerimientos de la contraseña",
			"passwordRequirementCharacters": "Al menos 8 caracteres",
			"passwordRequirementUppercase": "Una letra mayúscula",
			"passwordRequirementLowercase": "Una letra minúscula",
			"passwordRequirementNumber": "Un número",
			"passwordRequirementSpecial": "Un carácter especial",
			"passwordRequirementMetLabel": "{{requirementDescription}}: Requerimientos cumplido",
			"passwordRequirementNotMetLabel": "{{requirementDescription}}: no se cumple el Requerimientos"
		},
		"menuBar": {
			"dashboardButton": "Panel de control",
			"educationButton": "Educación",
			"resourcesButton": "Recursos",
			"profileButton": "Perfil"
		},
		"patientResources": {
			"header": "Recursos para el paciente",
			"infoHeader": "¿Qué son los recursos para el paciente?",
			"infoContent": "Estos enlaces son proporcionados por su Programa Bariátrico seleccionado. Al hacer clic en un enlace accederá a un sitio web de terceros, que no está gestionado por NewTri Health. No podemos garantizar la exactitud de ningún sitio web de terceros. Cuando siga el enlace, estará sujeto a la política de privacidad del sitio web de destino.",
			"infoCloseButton": "Listo",
			"infoOpenButton": "información abierta",
			"noResourcesAvailableMessage": "No hay recursos disponibles."
		},
		"welcome": {
			"imageLabel": "NewTri: nuevo cuerpo, nueva mente, nueva vida",
			"header": "Bienvenido a NewTri Health",
			"description": "NewTri® Health es un programa educativo interactivo con vídeos que le preparará para afrontar con éxito la cirugía bariátrica y le proporcionará las herramientas necesarias para mantenerse sano el resto de su vida.",
			"continueButton": "Empezar"
		},
		"login": {
			"logoLabel": "NewTri Health",
			"header": "Iniciar sesión",
			"emailInput": "Correo electrónico",
			"passwordInput": "Contraseña",
			"rememberEmailInput": "Recordar correo electrónico",
			"forgotPasswordLink": "¿Ha olvidado su contraseña?",
			"loginButton": "Iniciar sesión",
			"invalidCredentials": "Lo sentimos, pero su ID de usuario y/o contraseña no son válidos.",
			"generalError": "Algo ha ido mal al iniciar sesión. Por favor, inténtelo “$t(login.loginButton)” de nuevo."
		},
		"resetPassword": {
			"enterEmailHeader": "Restablecer contraseña",
			"emailInput": "Correo electrónico",
			"submitEmailButton": "Restablecer contraseña",
			"enterCodeHeader": "Verificar correo electrónico",
			"submitCodeButton": "Verificar",
			"changePasswordHeader": "Cambiar contraseña",
			"codeGenerationErrorMessage": "Algo ha ido mal. Por favor, intente pulsar “$t(resetPassword.submitEmailButton)” nuevamente.",
			"codeSent": "Hemos enviado el código a su correo electrónico <emphasis>{{emailAddress}}</emphasis> si hay una cuenta con esa dirección.",
			"codeExpiration": "El código expira en: <emphasis>{{timeInMinutesAndSeconds}}</emphasis>",
			"codeExpiredError": "El código ha caducado. Vuelva a enviar su correo electrónico para recibir un nuevo código.",
			"maximumAttemptsExceededError": "Ha introducido el código incorrectamente demasiadas veces o el código ya no es válido. Vuelva a enviar su correo electrónico para recibir un nuevo código.",
			"invalidCodeError": "Código incorrecto. Por favor, inténtelo de nuevo.",
			"codeValidationErrorMessage": "Algo ha ido mal al verificar el código. Por favor, inténtelo “$t(resetPassword.submitCodeButton)” de nuevo.",
			"startOverButton": "¿Utilizar un correo electrónico diferente? <emphasis>Empiece de nuevo.</emphasis>",
			"newPasswordInput": "Nueva contraseña",
			"passwordConfirmationInput": "Confirmar nueva contraseña",
			"passwordConfirmationMismatch": "Las contraseñas no coinciden",
			"submitPasswordButton": "Cambiar contraseña",
			"sessionExpiredError": "Su sesión ha caducado. Vuelva a enviar su correo electrónico para recibir un nuevo código.",
			"passwordUpdateError": "Algo ha ido mal al actualizar su contraseña. Por favor, intente pulsar “$t(resetPassword.submitPasswordButton)” de nuevo.",
			"cancelButton": "¿Ha cambiado de opinión? <emphasis>Iniciar sesión.</emphasis>",
			"successHeader": "¡Éxito!",
			"successMessage": "¡Su nueva contraseña ha sido establecida!",
			"loginButton": "Iniciar sesión"
		},
		"userProfile": {
			"header": "Perfil",
			"logoutButton": "Cerrar sesión",
			"nameInput": "Nombre",
			"firstNameInput": "Primer nombre",
			"lastNameInput": "Apellido",
			"emailInput": "Correo electrónico",
			"emailUpdateMessage": "Le enviaremos un correo electrónico de verificación a la dirección facilitada. Siga las instrucciones del correo electrónico para terminar de actualizar su dirección de correo electrónico.",
			"cellPhoneNumberInput": "Número de teléfono móvil",
			"cellPhoneNumberMessage": "Pueden aplicarse tarifas de mensajes y datos.",
			"passwordInput": "Contraseña",
			"currentPasswordInput": "Contraseña actual",
			"newPasswordInput": "Nueva contraseña",
			"newPasswordConfirmationInput": "Confirmar nueva contraseña",
			"newPasswordValidationError": "$t(userProfile.newPasswordInput) no cumple con los requisitos",
			"dateOfBirthInput": "Fecha de nacimiento",
			"sexInput": "Sexo",
			"missingValueMessage": "Por favor, actualice",
			"backToProfileButtonLabel": "volver al perfil",
			"sendEmailVerificationButton": "Enviar",
			"emailVerificationSentNotice": "Correo de verificación enviado.",
			"saveButton": "Guardar",
			"userLoadFailedError": "Se ha producido un error al cargar su profil.",
			"saveFailedError": "Algo ha ido mal al guardar sus cambios. Por favor, pruebe presionando “$t(userProfile.saveButton)” de nuevo.",
			"logoutModalHeader": "Cerrar sesión",
			"logoutModalMessage": "¿Está seguro de que desea salir de la aplicación?",
			"logoutModalRejectButton": "Cancelar",
			"logoutModalApproveButton": "Cerrar sesión"
		},
		"dashboard": {
			"profileLinkLabel": "Perfil",
			"selectTodayButton": "Hoy",
			"addLogButton": "Añadir",
			"saveFailedError": "Algo ha ido mal al guardar sus cambios. Por favor, pruebe presionando “$t(dashboard.addLogButton)” de nuevo.",
			"addLogModalMessage": "A partir de {{date, datetime(dateStyle: long)}}",

			"exerciseLogHeader": "Ejercicio",
			"exerciseLogActivitiesHeader": "Actividades",
			"addExerciseLogButton": "Añadir ejercicio",
			"updateExerciseLogButton": "Actualización del ejercicio",
			"addExerciseLogModalHeader": "¿Ha hecho ejercicio?",
			"exerciseYesButton": "Sí",
			"exerciseNoButton": "No",
			"exerciseActivitiesInput": "Actividades de ejercicio",
			"exerciseDurationInput": "Duración del ejercicio",
			"exerciseDurationHoursInput": "Horas de duración",
			"exerciseDurationMinutesInput": "Minutos de duración",
			"exerciseNoneMessage": "Ninguno",

			"weightLogHeader": "Peso",
			"addWeightLogButton": "Añadir peso",
			"updateWeightLogButton": "Actualizar peso",
			"addWeightLogModalHeader": "¿Cuál es su peso?",
			"weightInput": "Peso",
			"weightLogGraphDurationMessage": "Últimas 2 semanas",

			"foodLogHeader": "Comidas",
			"addFoodLogButton": "Añadir comidas",
			"addAdditionalMealButton": "Añadir comida",
			"addFoodLogModalHeader": "¿Cómo se siente con lo que ha comido?",
			"addFoodLogMealModalHeader": "¿Qué ha comido?",
			"mealTypeInput": "Comida",
			"mealTimeInput": "Hora de comer",
			"mealDescriptionInput": "¿Qué ha comido?",
			"ratingHeader": "Clasificación",
			"removeMealButton": "¿Eliminar comida?",
			"removeMealModalHeader": "Eliminar comida",
			"removeMealModalMessage": "¿Está seguro de que desea eliminar esta comida?",
			"removeMealModalApproveButton": "Eliminar",
			"removeMealModalRejectButton": "Cancelar",

			"waterLogHeader": "Agua",
			"addWaterLogButton": "Añadir agua",
			"updateWaterLogButton": "Actualizar agua",
			"incrementWaterLogConsumedButton": "Añadir 8 oz",
			"incrementWaterLogConsumedFailedMessage": "La actualización del agua ha fallado. Por favor, inténtelo de nuevo.",
			"waterLogConsumedHeader": "Consumido",
			"waterLogConsumedDescription_one": "{{count, number}} onza",
			"waterLogConsumedDescription_other": "{{count, number}} onzas",
			"addWaterLogModalHeader": "¿Cuánta agua ha consumido?",
			"waterAmountInput": "Cantidad consumida",
			"waterAmountInputUnit": "oz"
		},
		"education": {
			"header": "Educación",
			"quizzesHeader": "Cuestionarios",
			"quizzesDescription": "Promedio del examen integral",
			"allModulesHeader": "Todos los módulos",
			"moduleReleasedOn": "Publicado el: {{date, datetime(dateStyle: long)}}",
			"moduleAvailableOn": "Se publicará el: {{date, datetime(dateStyle: long)}}",
			"playButton": "Reproducir",
			"replayButton": "Repetición",
			"lessonCount_one": "{{count, number}} Clase",
			"lessonCount_other": "{{count, number}} Clases",
			"quizQuestionCount_one": "{{count, number}} Pregunta",
			"quizQuestionCount_other": "{{count, number}} Preguntas",
			"resumeLessonHeader": "Resumen de la clase",
			"currentLessonDescription": "Clase {{current}} de {{total}}",

			"videoPlayerShowControlsButton": "Mostrar controles",
			"videoPlayerHideControlsButton": "Ocultar controles",
			"videoPlayerPlayButton": "Reproducir",
			"videoPlayerPauseButton": "Pausar",
			"backToCourseButton": "Volver a la clase",
			"videoPlayerPositionLabel": "Posición de reproducción",
			"videoPlayerDurationLabel": "Duración del vídeo",
			"videoPlayerFullscreenButton": "Pantalla completa",
			"videoPlayerPositionSliderLabel": "Posición de reproducción",
			"videoRatingMessage": "¿Ha disfrutado del vídeo?",
			"videoRatingOptionLabel_one": "{{count, number}} estrella",
			"videoRatingOptionLabel_other": "{{count, number}} estrellas",
			"videoRatingSubmittedMessage": "¡Gracias!",

			"lessonHeader": "Clase {{lessonNumber}}: {{lessonName}}",
			"lessonDescriptionHeader": "Descripción",
			"tabClasses": "Clases",
			"tabAbout": "Acerca de",
			"tabFacts": "Hechos",
			"tabArticle": "Artículo",
			"tabQuiz": "Cuestionario",

			"backToLessonButtonLabel": "Volver a clase",
			"quizHeader": "Cuestionario",
			"quizSubmitButton": "Enviar respuestas",
			"quizResultsHeader": "Ha respondido correctamente a {{correctAnswerCount}} de {{questionCount}} preguntas ({{scorePercentage, number(style: percent)}})",
			"quizResultsLowScoreMessage": "Parece que lo ha pasado mal con el cuestionario de comprensión de esta clase. No se preocupe, a veces pasa.\n\nSi se siente atascado o necesita ayuda para asimilar la información, siempre puede ponerse en contacto con su centro quirúrgico, ¡estarán encantados de ayudarle!\n\nY asegúrese de revisar siempre la infografía de datos clave y la información complementaria de cada clase antes de realizar el cuestionario.",
			"quizResultsDoneButton": "Listo",
			"quizTabHeader": "Cuestionario de clase {{lessonNumber}} ",
			"quizTabDescription": "Realice el cuestionario de clase {{lessonNumber}} para completar esta sección.",
			"quizTabStartButton": "Hacer cuestionario",
			"quizTabResumeButton": "Resumen del cuestionario",
			"quizTabViewResultsButton": "Ver los resultados del cuestionario",
			"quizUnavailableAlertTitle": "No disponible",
			"quizUnavailableAlertMessage": "Tiene que terminar de ver la lección antes de realizar el cuestionario.",
			"quizUnavailableAlertDoneButton": "Listo",
			"quizAnswerSaveFailedMessage": "No se ha podido guardar la respuesta. Por favor, inténtelo de nuevo.",

			"completionHeader": "¡Curso completado al 100%!",
			"completionMessage": "¡Felicidades por completar el curso NewTri Health!",
			"completionCertificateButton": "Descargar certificado"
		},
		"appInfo": {
			"termsAndConditionsLink": "Términos y condiciones",
			"privacyPolicyLink": "Política de privacidad",
			"viewAppInfoButton": "Información de la App",
			"header": "Información de la App",
			"versionDetailsHeader": "Detalles de la versión",
			"checkButton": "Comprobar actualizaciones",
			"installButton": "Instalar actualización",
			"lastCheckedMessage": "Última revisión: {{time, datetime(dateStyle: long; timeStyle: short)}}",
			"updateAvailableMessage": "¡Nueva actualización disponible!",
			"upToDateMessage": "No hay nuevas actualizaciones disponibles."
		}
	}
}
